import { css } from "styled-components";

export const secondaryButtonStyles = (
  $type: "solid" | "outline" | "text",
  $dark?: boolean
) => {
  if ($type === "solid") {
    return css`
      background: var(--sec-orange-4);
      border: 0.1rem solid transparent;
      & > p {
        color: var(--text-gray-normal);
      }
      & > svg path {
        stroke: var(--text-gray-normal);
      }
      &:hover {
        background: rgba(255, 122, 33, 0.56);
      }
      &:active {
        background: ${$dark
          ? `linear-gradient(
            0deg, 
            rgba(254, 254, 254, 0.48) 0%, 
            rgba(254, 254, 254, 0.48) 100%
          ), 
          var(--sec-orange-4, #DA5D09)
        `
          : `linear-gradient(
            0deg,
            rgba(7, 7, 7, 0.48) 0%,
            rgba(7, 7, 7, 0.48) 100%
          ),
          var(--sec-orange-4, #ff7a21)`};
      }
      &.selected {
        background: var(--sec-orange-7);
      }
      &:disabled {
        background: var(--bg-gray-2);
        & > p {
          color: var(--text-gray-0);
        }
        & > svg path {
          stroke: var(--text-gray-0);
        }
      }
    `;
  }

  if ($type === "outline") {
    return css`
      background: transparent;
      border: 1px solid var(--sec-orange-4);
      & > p {
        color: var(--sec-orange-4);
      }
      & > svg path {
        stroke: var(--sec-orange-4);
      }
      &:hover {
        background: ${$dark
          ? "rgba(203, 203, 207, 0.24)"
          : "rgba(139, 139, 147, 0.24)"};
      }
      &:active {
        background: ${$dark
          ? "rgba(254, 254, 254, 0.32)"
          : "rgba(7, 7, 7, 0.32)"};
      }
      &.selected {
        background: var(--sec-orange-1);
        border: 1px solid var(--sec-orange-7);
        & > p {
          color: var(--sec-orange-7);
        }
        & > svg path {
          stroke: var(--sec-orange-7);
        }
      }
      &:disabled {
        background: transparent;
        border: 0.1rem solid var(--bg-gray-2);
        & > p {
          color: var(--bg-gray-2);
        }
        & > svg path {
          stroke: var(--bg-gray-2);
        }
      }
    `;
  }

  if ($type === "text") {
    return css`
      background: transparent;
      border: 0.1rem solid transparent;
      & > p {
        color: var(--sec-orange-4);
      }
      & > svg path {
        stroke: var(--sec-orange-4);
      }
      &:hover {
        background: ${$dark
          ? "rgba(203, 203, 207, 0.24)"
          : "rgba(139, 139, 147, 0.24)"};
      }
      &:active {
        background: ${$dark
          ? "rgba(254, 254, 254, 0.32)"
          : "rgba(7, 7, 7, 0.32)"};
      }
      &.selected {
        background: var(--sec-orange-1);
        & > p {
          color: var(--sec-orange-7);
        }
        & > svg path {
          stroke: var(--sec-orange-7);
        }
      }
      &:disabled {
        background: transparent;
        & > p {
          color: var(--bg-gray-2);
        }
        & > svg path {
          stroke: var(--bg-gray-2);
        }
      }
    `;
  }
};
